// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cmm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.cmm-modal {
  width: 390px;
  max-width: calc(100vw - 24px);
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}

.cmm-header {
  position: relative;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.cmm-title {
  font-size: 18px;
  font-weight: 800;
  text-align: center;
}

.cmm-close {
  position: absolute;
  right: 10px;
  border: none;
  background: transparent;
  cursor: pointer;
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cmm-close:hover {
  background: rgba(0, 0, 0, 0.06);
}

.cmm-headRow {
  display: grid;
  grid-template-columns: 1fr 160px;
  gap: 10px;
  padding: 10px 16px;
  font-weight: 700;
  color: rgba(0,0,0,0.55);
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.cmm-headLeft {
  text-align: left;
}

.cmm-headRight {
  text-align: right;
}

.cmm-list {
  max-height: 420px;
  overflow: auto;
}

.cmm-row {
  box-sizing: border-box;  /* ОБЯЗАТЕЛЬНО */
  font: inherit;    
  width: 100%;
  border: none;
  background: #fff;
  cursor: pointer;
  padding: 14px 16px;
  display: grid;
  grid-template-columns: 1fr 160px;
  gap: 10px;
  border-bottom: 1px solid rgba(0,0,0,0.08);
}

.cmm-row:hover {
  background: rgba(29, 135, 82, 0.05);
}

.cmm-row.selected {
  background: rgba(29, 135, 82, 0.08);
}

.cmm-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.cmm-name {
  font-weight: 700;
  color: #111;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cmm-right {
  text-align: right;
  font-weight: 800;
  color: #111;
}

.cmm-radio {
  width: 16px;
  height: 16px;
  border-radius: 999px;
  border: 2px solid rgba(0,0,0,0.25);
  display: inline-block;
  position: relative;
  flex: 0 0 auto;
}

.cmm-radio.on {
  border-color: rgba(29, 135, 82, 1);
}

.cmm-radio.on::after {
  content: "";
  position: absolute;
  inset: 3px;
  border-radius: 999px;
  background: rgba(29, 135, 82, 1);
}

.cmm-confirm {
  width: 100%;
  height: 54px;
  text-align: center;
  border: none;
  background: rgba(29, 135, 82, 1);
  color: #fff;
  font-weight: 900;
  cursor: pointer;
}

.cmm-confirm:hover {
  background: rgba(24, 115, 70, 1);
}
`, "",{"version":3,"sources":["webpack://./src/pages/SalesPages/CommissionSelectModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sBAAsB,GAAG,gBAAgB;EACzC,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,kCAAkC;EAClC,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,gCAAgC;EAChC,WAAW;EACX,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":[".cmm-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n}\n\n.cmm-modal {\n  width: 390px;\n  max-width: calc(100vw - 24px);\n  background: #fff;\n  border-radius: 14px;\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);\n  overflow: hidden;\n}\n\n.cmm-header {\n  position: relative;\n  padding: 14px 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.cmm-title {\n  font-size: 18px;\n  font-weight: 800;\n  text-align: center;\n}\n\n.cmm-close {\n  position: absolute;\n  right: 10px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  width: 34px;\n  height: 34px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cmm-close:hover {\n  background: rgba(0, 0, 0, 0.06);\n}\n\n.cmm-headRow {\n  display: grid;\n  grid-template-columns: 1fr 160px;\n  gap: 10px;\n  padding: 10px 16px;\n  font-weight: 700;\n  color: rgba(0,0,0,0.55);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n}\n\n.cmm-headLeft {\n  text-align: left;\n}\n\n.cmm-headRight {\n  text-align: right;\n}\n\n.cmm-list {\n  max-height: 420px;\n  overflow: auto;\n}\n\n.cmm-row {\n  box-sizing: border-box;  /* ОБЯЗАТЕЛЬНО */\n  font: inherit;    \n  width: 100%;\n  border: none;\n  background: #fff;\n  cursor: pointer;\n  padding: 14px 16px;\n  display: grid;\n  grid-template-columns: 1fr 160px;\n  gap: 10px;\n  border-bottom: 1px solid rgba(0,0,0,0.08);\n}\n\n.cmm-row:hover {\n  background: rgba(29, 135, 82, 0.05);\n}\n\n.cmm-row.selected {\n  background: rgba(29, 135, 82, 0.08);\n}\n\n.cmm-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.cmm-name {\n  font-weight: 700;\n  color: #111;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cmm-right {\n  text-align: right;\n  font-weight: 800;\n  color: #111;\n}\n\n.cmm-radio {\n  width: 16px;\n  height: 16px;\n  border-radius: 999px;\n  border: 2px solid rgba(0,0,0,0.25);\n  display: inline-block;\n  position: relative;\n  flex: 0 0 auto;\n}\n\n.cmm-radio.on {\n  border-color: rgba(29, 135, 82, 1);\n}\n\n.cmm-radio.on::after {\n  content: \"\";\n  position: absolute;\n  inset: 3px;\n  border-radius: 999px;\n  background: rgba(29, 135, 82, 1);\n}\n\n.cmm-confirm {\n  width: 100%;\n  height: 54px;\n  text-align: center;\n  border: none;\n  background: rgba(29, 135, 82, 1);\n  color: #fff;\n  font-weight: 900;\n  cursor: pointer;\n}\n\n.cmm-confirm:hover {\n  background: rgba(24, 115, 70, 1);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
